<template>
    <div>
        <div class="title">{{$t('news.lista')}}</div>
        <hr>
        <div class="container-fluid">
            <div class="row-sezione pt-0">
                <!-- foreach news -->
                <div class="py-2" v-for="notice in news">
                  <router-link :to="{name: 'news.details', params: {id: notice.id}}"
                               class="a1 d-flex align-items-center justify-content-start">
                      <div class="foto-news">
                        <div class="foto-news-cropper d-flex justify-content-center">
                          <img :src="getNewsImage(notice)" />
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <div class="gray d-flex align-items-center f13">{{moment(notice.created_at).locale(language).format('DD.MM.YYYY')}}</div>
                        <p class="text-uppercase mb-0"><b>{{notice.traduzione.titolo}}</b></p>
                      </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getMixedInfo} from "../../api/restaurant";
    import {getImage} from "../../api/core";
    import {mapState, mapActions} from "vuex";

    export default {
        data: function () {
            return {
                news: []
            }
        },
        created() {
            this.fetchInfo();
        },
        computed: {
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                targa: state => state.targa,
                locale: state => state.locale,
                id_ristorante: state => state.id
            })
        },
        watch: {
            language: function (newLanguage, oldLanguage) {
                this.fetchInfo();
            }
        },
        methods: {
            fetchInfo: function () {
                this.showLoading(true);
                getMixedInfo(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    news: true,
                }).then(response => {
                    this.news = response.news;
                }).catch(messages => {
                    alert(messages.join("\n"));
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            getNewsImage: function (news) {
                return getImage(this.language, this.id_ristorante, news.foto_codice);
            },
            displayNewsText: function (news) {
                return news.traduzione.testo.length > 200 ?
                    news.traduzione.testo.substr(0, 200).replace(/\n/g, '<br>') + ' ... ' : news.traduzione.testo.replace(/\n/g, '<br>')
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
